import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_variable_styled_bar = _resolveComponent("variable-styled-bar");
  const _component_bar_slot_with_value = _resolveComponent("bar-slot-with-value");
  return _openBlock(), _createBlock(_component_bar_slot_with_value, {
    loading: $props.loading,
    value: $props.value,
    color: $props.color,
    align: $props.align,
    gap: $props.gap,
    tight: $props.tight,
    reverse: $props.reverse
  }, {
    bar: _withCtx(() => [_ctx.$slots['custom-bar'] ? _renderSlot(_ctx.$slots, "custom-bar", {
      key: 0
    }, undefined, true) : (_openBlock(), _createBlock(_component_variable_styled_bar, {
      key: 1,
      value: $props.value,
      color: $props.color,
      min: $props.min,
      max: $props.max,
      height: $props.height
    }, null, 8, ["value", "color", "min", "max", "height"]))]),
    "bar-append": _withCtx(() => [_renderSlot(_ctx.$slots, "bar-append", {}, undefined, true)]),
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["loading", "value", "color", "align", "gap", "tight", "reverse"]);
}